import Typography from 'components/Typography';
import { ReactComponent as WelcomeIcon } from 'icons/welcome-image.svg';
import T from 'prop-types';
import React from 'react';

import styles from './Welcome.module.scss';

const Welcome = ({ first_name, username }) => (
  <div className={styles.welcomeWrapper}>
    <WelcomeIcon />

    <Typography className="mgt-25 mgb-20" type="h4">{`Welcome ${first_name || username}!`}</Typography>

    <Typography className={styles.description}>
      Before you can see any class data on your dashboard you must create a class.
    </Typography>
  </div>
);

Welcome.propTypes = {
  username: T.string.isRequired,
  first_name: T.string,
};

export default Welcome;
